module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "150px"
    }
  }, [_c('em', [_vm._v("“Come away, O human child!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("To the waters and the wild")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("With a faery, hand in hand,")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("For the world’s more full of weeping")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Than you can understand")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("William Butler Yeats 1865–1939")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("The leaden mist of autumn dawn lay still and stifling as it cloaked the town, its careless mercy giving shelter as men slept through stifled fears. Their womenfolk sought immersion in the practicalities of living, leaving concerns with the puzzlement of life to those who had the time.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Rivertown, being so-called on account of its natural waterway that ran from one end of the town to the other, boasted a flour mill and accompanying mill wheel that rode the river as it idled or thundered with an indifference to the changing seasons.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Ruth Kelly, nee Kinsella, experienced a faint feeling of inner joy as she walked along River Street in the company of her two young boys and her man. Thomas at the time was aged thirteen and his brother, John Junior, two years younger. She had become accustomed to her husband’s ironic indifference to the respect of other men whose: “All right, John?” was a familiar manner of acknowledgement towards a man who was known for his outstanding courage as a United Nations soldier.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Whenever she remarked on her husband’s absence of response, John had registered no more than a slight movement of his mouth. It was not an expression of modesty but an instinctive reaction as though to suggest that life had a more gruesome aspect, one which found solitary expression in disturbing dreams and alarming flashbacks of his wartime experience. A single exception to his casual indifference towards others was Martin Heaton, science instructor at the town’s technical college.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('em', [_vm._v("That man,")]), _vm._v(" thought Ruth, "), _c('em', [_vm._v("knows something that is shared with my husband but I don’t know what it is.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("What it was seemed reflected in their common reluctance to live by the town’s conventions or indeed, so far as she knew, those of the Irish people.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0